import { all, call, put, takeEvery } from 'redux-saga/effects';
import type { ITemplateResponse } from '../../lib/api/template/template-api';
import * as templateApi from '../../lib/api/template/template-api';
import { errorToast, setLoading } from '../pageFrame/actions';
import * as actions from './actions';
import type { ITemplateMetadata } from './types';

const ActionTypes = actions.ActionTypes;

export function* handleFetchTemplates(_action: ReturnType<typeof actions.fetchTemplates>) {
  try {
    const res: ITemplateResponse<ITemplateMetadata[]> = yield call(templateApi.getTemplates, { fetchShares: true });
    const templates = res.result;
    if (res.status !== 200) {
      throw Error(`Non-200 Status Code of Templates GET: ${res.status}`);
    }
    yield put(actions.fetchTemplatesDone(templates!));
  } catch {
    yield put(actions.fetchTemplatesError('Error fetching Templates'));
  }
}

export function* handleCreateTemplate(_action: ReturnType<typeof actions.createTemplate>) {
  try {
    yield put(setLoading(true));
    const res: ITemplateResponse<ITemplateMetadata> = yield call(templateApi.createTemplate);
    const template = res.result;
    if (res.status !== 201) {
      throw Error(`Non-201 Status Code of Templates POST: ${res.status}`);
    }
    yield put(actions.createTemplateDone(template!));
  } catch {
    yield put(actions.createTemplateError('Error Creating Template'));
  } finally {
    yield put(setLoading(false));
  }
}

export function* handleDeleteTemplate(action: ReturnType<typeof actions.deleteTemplate>) {
  try {
    const res: ITemplateResponse<ITemplateMetadata> = yield call(templateApi.deleteTemplate, action.payload.templateId);
    if (res.status !== 204) {
      throw Error(`Non-204 Status Code of Template DELETE: ${res.status}`);
    }
    yield put(actions.fetchTemplates());
  } catch {
    yield put(actions.deleteTemplateError('Error Deleting Template'));
  }
}

export function* handleCreateEnvelopeFromTemplate(action: ReturnType<typeof actions.createEnvelopeFromTemplate>) {
  try {
    const res: Awaited<ReturnType<typeof templateApi.createEnvelopeFromTemplate>> = yield call(
      templateApi.createEnvelopeFromTemplate,
      action.payload
    );
    yield put(actions.createEnvelopeFromTemplateDone(res.value.envelopeId));
  } catch {
    yield put(errorToast('Failed to create envelope. Please try again.'));
  } finally {
    yield put(setLoading(false));
  }
}

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default function* rootSaga() {
  yield all([
    takeEvery(ActionTypes.FETCH_TEMPLATES, handleFetchTemplates),
    takeEvery(ActionTypes.CREATE_TEMPLATE, handleCreateTemplate),
    takeEvery(ActionTypes.DELETE_TEMPLATE, handleDeleteTemplate),
    takeEvery(ActionTypes.CREATE_ENVELOPE_FROM_TEMPLATE, handleCreateEnvelopeFromTemplate),
  ]);
}
